import React from 'react';
import { TextField, InputAdornment } from '@mui/material';
import { AttachMoneyOutlined } from '@mui/icons-material';
import { useFacilityMaintenanceEditor } from '../../../../../hooks/useFacilityMaintenanceEditor';
import { EditorMode } from '../../../../../types/editorTypes';

interface Props {
  mode: EditorMode;
}

export const FacilityMaintenanceEstimatedCostEditor: React.FC<Props> = ({ mode }) => {
  const { request, updateRequest } = useFacilityMaintenanceEditor(mode);

  const handleChange = (value: string) => {
    const parsed = parseFloat(value);
    updateRequest({ estimatedCost: isNaN(parsed) ? undefined : parsed });
  };

  return (
    <TextField
      label="Estimated Cost"
      value={request?.estimatedCost ?? ''}
      onChange={(e) => handleChange(e.target.value)}
      size="small"
      fullWidth
      type="number"
      placeholder="0.00"
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <AttachMoneyOutlined sx={{ color: '#64748b', fontSize: 18 }} />
          </InputAdornment>
        ),
      }}
    />
  );
};

export default FacilityMaintenanceEstimatedCostEditor;
